module.exports = __webpack_public_path__ + "static/media/logout-icon.6488653d.svg";